// Migrations must be listed in ascending schema_version order.
// To add a new migration, create a file under app/frontend/migrations/<n>.js
// and import + add it to this array.
import migration1 from '../migrations/1.js';
import migration2 from '../migrations/2.js';
import migration3 from '../migrations/3.js';

const migrations = [
  migration1,
  migration2,
  migration3,
];

// Current schema version — must match the highest migration's schema_version.
export const CURRENT_SCHEMA_VERSION = 3;

export default class Migration {
  // Returns the subset of migrations that need to run to bring config up to
  // CURRENT_SCHEMA_VERSION. Configs with no schema_version field (or
  // lastUpdatedWithVersion but no schema_version) are treated as schema version 0.
  static pending(config) {
    const configVersion = config.schema_version ?? 0;

    return migrations.filter(m => m.schema_version > configVersion);
  }

  // Runs all pending migrations in order, stamps schema_version, and returns
  // the mutated config.
  static run(config) {
    const pending = Migration.pending(config);
    pending.forEach(m => m.migrate(config));
    config.schema_version = CURRENT_SCHEMA_VERSION;
    return config;
  }
}
